import http from '@/plugins/axios/axios';

export default class ClienteIKAcessoService {

    constructor() {
        this.baseUrl = process.env.VUE_APP_BASE_URL_ADMIN_IKACESSO;
    }

    /**
     * Salva a conta do cliente IK Acesso.
     * @param {} requisicao 
     * @returns 
     */
    salvarConta(requisicao) {       
        return http.request({
            method: 'post', 
            withCredentials: true,
            url: this.baseUrl+'/api/conta/v1',
            data: requisicao
        });
    }

    /**
     * Salva somente dados do cliente IK Acesso.
     * @param {} requisicao 
     * @returns 
     */
    alterar(requisicao) {       
        return http.request({
            method: 'put', 
            withCredentials: true,
            url: this.baseUrl+'/api/cliente/v1',
            data: requisicao
        });
    }

    atualizarStatusConta(id, status) {       
        return http.request({
            method: 'put', 
            withCredentials: true,
            url: this.baseUrl+'/api/conta/v1/atualizar-status/'+id+'?status='+status
        });
    }

    buscarConta(id) {       
        return http.request({
            method: 'get', 
            withCredentials: true,
            url: this.baseUrl+'/api/conta/v1/'+id,
        });
    }

    /**
     * Atualiza somente os dados pessoais do cliente.
     * @param {*} clienteId
     * @param {*} dados
     */
    alterarDadosCliente(clienteId, dados) {
        return http.request({
            method: 'put',
            withCredentials: true,
            url: this.baseUrl + '/api/cliente/v1/' + clienteId,
            data: dados
        });
    }

    /**
     * Atualiza o endereço do cliente.
     * @param {*} contaId
     * @param {*} endereco
     */
    alterarEndereco(contaId, endereco) {
        return http.request({
            method: 'put',
            withCredentials: true,
            url: this.baseUrl + '/api/cliente/v1/atualizar-endereco/' + contaId + '',
            data: endereco
        });
    }

    /**
     * Atualiza o plano do cliente.
     * @param {*} contaId
     * @param {*} plano
     */
    alterarPlanoConta(contaId, plano) {
        return http.request({
            method: 'put',
            withCredentials: true,
            url: this.baseUrl + '/api/conta/v1/atualizar-plano/' + contaId + '',
            data: plano
        });
    }

    listarContas(valorBusca, pagina, totalPorPagina) {
        return http.request({
            method: 'get',
            withCredentials: true,
            url: this.baseUrl+`/api/conta/v1?valorBusca=${encodeURIComponent(valorBusca)}&pagina=${pagina}&totalPorPagina=${totalPorPagina}`
        });
    }

    atualizarModoOperacaoConta(id, modoOperacao) {
        return http.request({
            method: 'put',
            withCredentials: true,
            url: this.baseUrl + '/api/conta/v1/atualizar-modo-operacao/' + id + '?modoOperacao=' + modoOperacao
        });
    }

    listarLogsUsuariosOperacoes(dataInicio, dataFinal, usuarioId, pagina, totalPorPagina) {
        let url = this.baseUrl + `/api/log-usuario/v1?dataInicio=${dataInicio}&dataFinal=${dataFinal}&pagina=${pagina}&totalPorPagina=${totalPorPagina}`;
        if (usuarioId) {
            url += `&usuarioId=${usuarioId}`;
        }
        return http.request({
            method: 'get',
            withCredentials: true,
            url
        });
    }

    listarUsuarios() {
        return http.request({
            method: 'get',
            withCredentials: true,
            url: this.baseUrl + '/api/admin/v1/usuarios-logs'
        });
    }

}